import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageModule } from '../utils/storage.module';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root',
  })
export class ErrorService {

    private _display:boolean = false; 
    public  items = []; 

    constructor(private storage: StorageModule, private router: Router){ }
    
    public get display(){
        return this._display;
    }

    public hide(){
        this._display = false;
    }

    public show(){
        this._display = true;
    }

    public add(error){
        this.items.push({
            title:  moment( Date.now()).toString(), description:error });
    }

    public clear(){
        this.items = [];
    }
}
